import type { IconData } from '@stacksjs/iconify-core'

export const ltr: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9 2v9a1 1 0 0 1-2 0V6H6a3 3 0 1 1 0-6h7a1 1 0 0 1 0 2h-1v9a1 1 0 0 1-2 0V2zM1.657 9L.284 10.36a.955.955 0 0 0 0 1.358a.977.977 0 0 0 1.373 0L3.716 9.68a.955.955 0 0 0 0-1.36l-2.06-2.038a.977.977 0 0 0-1.372 0a.955.955 0 0 0 0 1.359zM7 2H6a1 1 0 1 0 0 2h1z\"/>",
  "width": 14,
  "height": 12,
  "viewBox": "0 0 14 12"
}

export default ltr
